import { ReactNode } from 'react';
import { Icon, Icons } from './Icon';
import { useLocalization } from './localization';
import { cleanNumeric, formatPhoneNumberWithDashes } from './StringHelper';

interface CustomerServicePhoneLinkProps {
    className?: string;
    children?: ReactNode;
    isConsumerPrivacy?: boolean;
    icon?: Icons;
    phone?: string;
}

export function CustomerServicePhoneLink({ className, children, isConsumerPrivacy, icon, phone }: CustomerServicePhoneLinkProps) {
    const locale = useLocalization();
    let phonenum =
        formatPhoneNumberWithDashes(phone ?? (isConsumerPrivacy ? locale.consumerPrivacyPhone : locale.customerServicePhone)) ?? '';
    return (
        <a href={`tel:${cleanNumeric(phonenum)}`} className={className} title={`Contact Customer Service at ${phonenum}`}>
            {icon && <Icon name="phone" className="mr-2" />}
            <span style={{ whiteSpace: 'nowrap' }}>{children ?? phonenum}</span>
        </a>
    );
}
